import { getStoredFeedback, storeFeedback } from './_utils/feedback';
import FeedbackButton from '@/pages/NewsBriefing/_components/FeedbackButton';
import { AnimatePresence, motion } from 'framer-motion';
import { useState, useEffect } from 'react';

import { DisappointingDialog } from './DisappointingDialog';

export const GASection = () => {
  const [feedback, setFeedback] = useState<'satisfying' | 'disappointing' | null>(null);

  const renderFeedback = () => {
    switch (feedback) {
      case 'satisfying':
        return <SatisfyingText />;
      case 'disappointing':
        return <DisappointingText />;
      case null:
        return <InitailFeedback handleFeedback={handleFeedback} />;
      default:
        return <InitailFeedback handleFeedback={handleFeedback} />;
    }
  };
  useEffect(() => {
    setFeedback(getStoredFeedback());
  }, []);

  const handleFeedback = (value: 'satisfying' | 'disappointing') => {
    setFeedback(value);
    storeFeedback(value);
  };

  return (
    <div className="flex min-h-[34px] w-full flex-col items-center gap-[12px] overflow-hidden text-gr-700 Body5M14">
      <AnimatePresence mode="wait">
        <motion.div
          key={feedback}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          className="flex w-full justify-center"
        >
          {renderFeedback()}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export type InitailFeedbackProps = {
  handleFeedback: (value: 'satisfying' | 'disappointing') => void;
};

const InitailFeedback = ({ handleFeedback }: InitailFeedbackProps) => {
  return (
    <div className="flex w-full items-center justify-center gap-[12px] text-gr-700 Body5M14">
      <p className="text-gr-700 Body5M14">오늘의 뉴스 어땠나요?</p>
      <div className="flex items-center gap-[8px]">
        <SatisfyingButton handleFeedback={handleFeedback} />
        <DisappointingDialog handleFeedback={(value) => handleFeedback(value)} />
      </div>
    </div>
  );
};

const SatisfyingButton = ({ handleFeedback }: InitailFeedbackProps) => {
  return <FeedbackButton onClick={() => handleFeedback('satisfying')}>😊 좋아요</FeedbackButton>;
};

const SatisfyingText = () => {
  return (
    <FeedbackButton className="rounded-sm bg-gr-100 px-2.5 py-1.5">
      앞으로도 유익한 소식만 알려드릴게요❤️
    </FeedbackButton>
  );
};

const DisappointingText = () => {
  return <FeedbackButton>다음 뉴스에 잘 반영할게요 🔥</FeedbackButton>;
};
